import axios from 'axios'
import CreateCodeGroup from './dto/CreateCodeGroup'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedCodeGroupResultRequestDto} from './dto/PagedCodeGroupResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllCodeGroups from './dto/GetAllCodeGroups'
import UpdateCodeGroup from './dto/UpdateCodeGroup'
import GetCodeGroup from './dto/GetCodeGroup'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/CodeGroup/Create`
export const URL_DELETE = `${API_URL}/CodeGroup/Delete`
export const URL_GET = `${API_URL}/CodeGroup/Get`
export const URL_GET_ALL = `${API_URL}/CodeGroup/GetPagedAll`
export const URL_UPDATE = `${API_URL}/CodeGroup/Update`

export function onCreateCodeGroup(createCodeGroup: CreateCodeGroup): Promise<boolean> {
  return axios.post(URL_CREATE, createCodeGroup)
}

export function onDeleteCodeGroup(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetCodeGroup(entityDto: EntityDto): Promise<GetCodeGroup> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllCodeGroups(
  pagedFilterAndSortedRequest: PagedCodeGroupResultRequestDto
): Promise<PagedResultDto<GetAllCodeGroups>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateCodeGroup(updateCodeGroupInput: UpdateCodeGroup): Promise<boolean> {
  return axios.put(URL_UPDATE, updateCodeGroupInput)
}
